export default { sha: '69bc9baaf74e2b1bc522f4d80f117882cfaec3c7', buildNumber: 'undefined' }
